import styled from 'styled-components'

const Container = styled.div`
  background: #272B4A;
  border: 0.688106px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 1.25rem 1.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;

  &:hover {
    border-color: ${({ theme }) => theme.primary};
    transform: translateY(-2px);
  }

  .company--info {
    display: flex;
    gap: 1rem;
    align-items: flex-start;
    flex: 1;
    min-width: 0;

    .company--avatar {
      width: 48px;
      height: 48px;
      min-width: 48px;
      border-radius: 8px;
      background: ${({ theme }) => theme.primary};
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.25rem;
      font-weight: 600;
      flex-shrink: 0;
    }

    .company--details {
      flex: 1;
      min-width: 0;

      h3 {
        font-size: 1rem;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.9);
        margin: 0 0 0.375rem 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .email {
        font-size: 0.875rem;
        color: rgba(255, 255, 255, 0.7);
        margin: 0 0 0.25rem 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .contact {
        font-size: 0.8125rem;
        color: rgba(255, 255, 255, 0.6);
        margin: 0;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        strong {
          font-weight: 500;
          color: rgba(255, 255, 255, 0.7);
        }
      }
    }
  }

  .status--badge {
    padding: 0.375rem 0.875rem;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.025em;
    white-space: nowrap;
    flex-shrink: 0;
    
    &.active {
      background: #6ABA6D;
      color: #fff;
    }

    &.inactive {
      background: #ef4444;
      color: #fff;
    }

    &.suspended {
      background: #f39c12;
      color: #fff;
    }

    &.pending {
      background: #3b82f6;
      color: #fff;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

    .company--info {
      width: 100%;
    }

    .status--badge {
      align-self: flex-start;
    }
  }
`

export default Container
